import React, { useState, useContext } from 'react';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import { Loader } from '@alumni-ventures-group/react-shared/lib/components';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import VenturePlanningToolIntro from '../Preamble/VenturePlanningToolIntro';
import SmartVentureInvesting from '../Preamble/SmartVentureInvesting';
import ConstructingVenturePortfolio from '../Preamble/ConstructingVenturePortfolio';
import { PlanContext } from '../context/PlanContext';

const Preamble = ({ onComplete }) => {
  const {
    planningConfig,
    userPortfolio,
    saveUserPortfolio,
    setPlanningButtonLoading,
  } = useContext(PlanContext);
  const [preamblePageIndex, setPreamblePageIndex] = useState(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  if (!planningConfig?.preamble || !userPortfolio) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        <Loader />
      </Box>
    );
  }

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  const handlePreamblePageContinue = async () => {
    setPlanningButtonLoading(true);
    try {
      if (preamblePageIndex < 2) {
        setPreamblePageIndex(preamblePageIndex + 1);
        scrollToTop();
      } else {
        await saveUserPortfolio({
          userIntegrationId: userPortfolio.integrationId,
          investmentPlanPreambleCompletedDate: new Date().toISOString(),
        });
        onComplete();
      }
    } catch (error) {
      console.error('Error saving venture plan introduction progress:', error);
    } finally {
      setPlanningButtonLoading(false);
    }
  };

  switch (preamblePageIndex) {
    case 0:
      return (
        <VenturePlanningToolIntro
          title={planningConfig?.preamble?.venturePlanningTool?.title}
          bodyContent={
            planningConfig?.preamble?.venturePlanningTool?.bodyCopy?.richtext
          }
          buttonText={planningConfig?.preamble?.venturePlanningTool?.buttonCopy}
          disclaimer={
            planningConfig?.preamble?.venturePlanningTool?.disclaimer?.richtext
          }
          onContinue={handlePreamblePageContinue}
          isMobile={isMobile}
        />
      );
    case 1:
      return (
        <SmartVentureInvesting
          title={planningConfig?.preamble?.smartVentureInvesting?.title}
          leftColumnContent={
            planningConfig?.preamble?.smartVentureInvesting?.bodyCopy?.richtext
          }
          rightColumnImage="https://blackbriar-media-prod.s3.amazonaws.com/animations/avwa_anim04_deliver.mov"
          buttonText={
            planningConfig?.preamble?.smartVentureInvesting?.buttonCopy
          }
          onContinue={handlePreamblePageContinue}
          isMobile={isMobile}
        />
      );
    case 2:
      return (
        <ConstructingVenturePortfolio
          image={planningConfig?.preamble?.venturePortfolio?.image?.url}
          buttonText={planningConfig?.preamble?.venturePortfolio?.buttonCopy}
          onContinue={handlePreamblePageContinue}
          isMobile={isMobile}
        />
      );
    default:
      return null;
  }
};

Preamble.propTypes = {
  onComplete: PropTypes.func.isRequired,
};

export default Preamble;
